
<template>
  <div>
    <div class="rightNumber">
      <div class="imgBox">
        <img src="../../../static/u1802.svg" alt="">
      </div>
      <div class="numberText">
        <div class="totalText">AEO总数</div>
        <div class="totalText1">Volume of AEO</div>
        <div class="totals">{{aeoTotalCompanyNum}}</div>
      </div>
    </div>
    <div class="box" style="padding:0px;margin-top:15px">
      <div class="boxTitle">
        <div class="boxTitle-text">AEO名单 AEO List</div>
        <div class="boxTitle-search">
          <div class="boxTitle-search1">搜索：</div>
          <div class="boxTitle-search2">
            <input v-model="searchText" @change="changeSearch"/>
          </div>
          <div class="boxTitle-search3" @click="clearSearch">清空</div>
        </div>
      </div>
      
      <div class="echart">
       <dv-scroll-board :config="config" style="width:100%;height:90vh" />
      </div>
    </div>

  </div>

</template>

<script>
	export default {
		name: "eight",
		data() {
      return {
        aeoTotalCompanyNum:0,
        copyData: [],
        config:{
            data: [],
            align: ['left'],
            columnWidth: [130],
            rowNum: 25,
            headerBGC: '#1981f6',
            headerHeight: 45,
            oddRowBGC: 'rgba(0, 44, 81, 0.8)',
            evenRowBGC: '#0D3769'
        },
        searchText: ''
      }
		},
    mounted() {
      this.$Bus.$on('getCustomCompanyData', e => {//AEO进出口贸易分布
        let data = e.companyDataList;
        this.aeoTotalCompanyNum = e.aeoTotalCompanyNum;
        let arr = [];
        for(let i=0;i<data.length;i++){
          arr.push([data[i].customName,data[i].countryName])
        }
        this.config.data = arr;
        this.copyData = JSON.parse(JSON.stringify(arr));
        this.config = { ...this.config }
      })
    },
    methods:{
      datainfo() {

      },
      changeSearch(v){
        console.log(v)
        const text = v.target.value;
        console.log(this.copyData)
        const newData = this.copyData.filter(item => item[1].toLowerCase().indexOf(text.toLowerCase()) > -1)
        console.log(newData)
        this.config.data = newData;
        this.config = { ...this.config }
      },
      clearSearch(){
        this.searchText= '';
        this.config.data = JSON.parse(JSON.stringify(this.copyData));
        this.config = { ...this.config }
      }
    }
	}

</script>

<style scoped>
  .boxTitle{
    width: 100%;
    padding: 15px 15px 15px 15px;
    border-left: 6px solid #00ADEF;
    font-size: 24px;
  }
  .boxTitle-search{
    display:flex;
    padding-top: 12px;
  }
  .boxTitle-search1{
    font-size: 16px;
    color:#1AC7FD;
    line-height: 40px;
    padding-right: 10px;
  }
  .boxTitle-search2{
    flex: 1;
  }
  .boxTitle-search2 input{
    width: 100%;
    border: 1px solid #d7ebfd;
    height: 40px;
    background: transparent !important;
    color: #fff;
    font-size: 24px;
    padding: 0 10px;
  }
  .boxTitle-search3{
    font-size: 16px;
    color:#1AC7FD;
    line-height: 40px;
    padding: 0 10px;
  }
  .totalText{
    font-size: 20px;
    color:#1AC7FD;
    font-family: '微软雅黑';
    font-weight: 400;
  }
  .totalText1{
    font-size: 16px;
    color:#1AC7FD;
    font-family: '微软雅黑';
        font-weight: 400;
  }
  .totals{
    font-size:28px;
    color:#FFFFFF;
  }
  .rightNumber{
    display: flex;
    align-items: center;
    font-family: '微软雅黑';
    font-weight: 400;
    justify-content: center;
  }
  .imgBox{
    width: 70px;
    height: 70px;
    background: inherit;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    border-width: 4px;
    border-style: solid;
    border-color: rgba(49, 167, 255, 1);
    border-radius: 188px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    color: #FFFFFF;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .imgBox img{
    width: 42px;
    height: 42px;
  }
  .numberText{
    border-width: 0px;
    width: 240px;
    height: 110px;
    background: inherit;
    background-color: rgba(26, 201, 255, 0.298039215686275);
    border: none;
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    border-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    text-align: left;
    margin-left:15px;
    padding:15px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/rightNew/rightOne.vue